export default "__VITE_ASSET__2tuBcd7E__"